const TODO_CHANGE = 'todo_change'
const ORGDATA_SEARCH = 'orgdata_search'

const EVENTLIST = {
  // L-nav监测show-table的变化
  TODO_CHANGE,
  ORGDATA_SEARCH
}
export default {EVENTLIST}



// WEBPACK FOOTER //
// ./src/eventbus/eventlist.js